import {
  InformationCircleIcon,
  RectangleGroupIcon,
} from '@heroicons/react/24/outline';
import { MultiSelect } from '../multi-select';
import { SkeletonLoader } from '../skeleton-loader';
import { Tooltip } from '../tooltip';
import { FilterControls, IntegrationGroupFilter } from './filter-types';

import { useTranslation } from 'react-i18next';

const MAX_TEXT_LENGTH = 27;

export const IntegrationGroupFC = ({
  error,
  data,
  id,
  label,
  loading,
  value,
  setValue,
  placement,
  hideIcon,
  onClose,
  permanent,
  displayMaxItems,
  selectText,
  showInlineClear,
  showOperator,
  wrapperClassName,
  dataTestId,
}: IntegrationGroupFilter & FilterControls) => {
  const { t } = useTranslation('designSystem');
  return (
    <SkeletonLoader
      status={loading ? 'loading' : error ? 'error' : 'success'}
      error={error}
      type="line"
      key={id}
    >
      <MultiSelect
        dataTestId={dataTestId}
        label={label || t('integrationGroup')}
        loading={loading}
        allowSearch
        showOperator={showOperator}
        displayButtonClassName={wrapperClassName}
        options={
          data?.map(({ name, groupId }) => {
            const isTextTruncated = name.length > MAX_TEXT_LENGTH;
            return {
              value: groupId,
              searchString: name,
              label: (
                <div className="flex flex-col truncate">
                  <div className="flex items-center gap-1">
                    <div className="mr-1 truncate">{name}</div>
                    {isTextTruncated && (
                      <Tooltip
                        label={name}
                        style={{
                          maxWidth: '500px',
                        }}
                      >
                        <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-gray-600 dark:text-gray-400" />
                      </Tooltip>
                    )}
                  </div>
                </div>
              ),
              selectedDisplay: name,
            };
          }) || []
        }
        icon={RectangleGroupIcon}
        mode="multiple"
        showInlineClear={showInlineClear}
        showClear
        showSelectAll
        value={value}
        setValue={setValue}
        hideIcon={hideIcon}
        placement={placement}
        displayMaxItems={displayMaxItems}
        onClose={onClose}
        selectText={selectText}
        permanent={permanent}
      />
    </SkeletonLoader>
  );
};
